import { createContext, useCallback, useContext, useEffect, useState } from "react";
import useGlobal from "../../../util/Global";
import useMessage from "../../../util/useMessagev2";
import { useSelector } from "react-redux";
import AdayBasvurularservice from "../../../service/Ebasvuru/AdayBasvurularService";
import { Backdrop, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import { CloseSharp } from "@mui/icons-material";
import BasvuruFormuBlokservice from "../../../service/Ebasvuru/AdayDomain/BasvuruFormuBlokService";

const BasvuruContext = createContext();

export const ShareProvider = ({ children }) => {

    const [modulKriterler, setModuleKriter] = useState([]);
    const { user } = useSelector(user => user.auth);
    const showMessage = useMessage();
    const [isChange, setIsChange] = useState(false);
    const [isPageValid, setIsPageValid] = useState(false);
    const { t } = useGlobal();
    const [open, setOpen] = useState(false);

    const [confirmOpen, setConfirmOpen] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    const [onConfirm, setOnConfirm] = useState(() => () => { });
    const [basvuruFormBlokId, setbasvuruFormBlokId] = useState(null);
    const [isClose, setClosed] = useState(false);



    /// this method to add normal kriteler 
    const updateSelKriterler = (newKriterler) => {
        setModuleKriter((prevKriterler) => {

            const existingIndex = prevKriterler.findIndex(
                (item) => item.modulId === newKriterler.modulId
            );

            if (existingIndex !== -1) {
                // Update existing object
                return prevKriterler.map((item, index) =>
                    index === existingIndex ? newKriterler : item
                );
            } else {
                // Add new object
                return [...prevKriterler, newKriterler];
            }
        });

        setIsChange(true);

        //   validateCurrentBlock();


        /*  console.log(" selKriterler:", {
              basvuruformuId: user.basvuruformu,
              adayId: user.userId,
              kriterList: modulKriterler
          });*/
    };


    /// this method to add Komponent kritler where kriter komponent is list here
    const updateKomponentKriterler = (newKomponentKriterler) => {
        setModuleKriter((prevKriterler) => {
            // Find the index of the item based on modulId and kriterKomponent
            const existingIndex = prevKriterler.findIndex(
                (item) =>
                    item.modulId === newKomponentKriterler.modulId &&
                    item.kriterKomponent === newKomponentKriterler.kriterKomponent
            );

            if (existingIndex !== -1) {
                // If modulId and kriterKomponent exists, update KomponentKriterler by adding new elements
                return prevKriterler.map((item) =>
                    item.modulId === newKomponentKriterler.modulId &&
                        item.kriterKomponent === newKomponentKriterler.kriterKomponent
                        ? {
                            ...item,
                            komponentKriterler: [
                                ...item.komponentKriterler, // Keep existing KomponentKriterler
                                ...newKomponentKriterler.komponentKriterler, // Add new ones
                            ],
                        }
                        : item
                );
            } else {
                // If modulId doesn't exist, create a new entry with the new KomponentKriterler
                return [
                    ...prevKriterler,
                    {
                        modulId: newKomponentKriterler.modulId,
                        kriterler: {},
                        kriterKomponent: newKomponentKriterler.kriterKomponent,
                        komponentKriterler: newKomponentKriterler.komponentKriterler,
                    },
                ];
            }
        });

        setIsChange(true);

        validateCurrentBlock();

        /*   console.log("komponentKriterler:", {
               basvuruformuId: user.basvuruformu,
               adayId: user.userId,
               kriterList: modulKriterler,
           });*/
    };

    /// this method to delete item Komponent kritler where kriter komponent is list here
    const deleteKomponentKriterler = (modulId, kriterKomponent, indexToRemove) => {
        setModuleKriter((prevKriterler) => {
            // Find the index of the item based on modulId and kriterKomponent
            const existingIndex = prevKriterler.findIndex(
                (item) => item.modulId === modulId && item.kriterKomponent === kriterKomponent
            );

            if (existingIndex !== -1) {
                // If the item with the specified modulId and kriterKomponent exists, update KomponentKriterler
                return prevKriterler.map((item, index) =>
                    index === existingIndex
                        ? {
                            ...item,
                            komponentKriterler: item.komponentKriterler.filter(
                                (_, idx) => idx !== indexToRemove
                            ), // Remove the element at the specified index
                        }
                        : item
                );
            }

            return prevKriterler; // Return the previous state if no match is found
        });

        setIsChange(true);

        validateCurrentBlock();

        /*    console.log("komponentKriterler after deletion:", {
                basvuruformuId: user.basvuruformu,
                adayId: user.userId,
                kriterList: modulKriterler,
            });*/
    };

    const getKriterler = () => {
        try {
            AdayBasvurularservice.getAdayBasvurForm({
                projId: user.iapId,
                adayId: user.userId,
                basvuruFormuId: user.basvuruId,
            }).then((res) => {

                if (res && res.resultObject) {
                    setModuleKriter(res.resultObject?.kriterList);
                    /*  console.log("read from db");
                      console.log(res.resultObject.kriterList);*/

                }
            });
        } catch (error) {
            console.log(error);
        }
    }

    const deleteFromDb = ({ refId, modulId, komponentId, kriterId, index }) => {

        setOpen(true);
        try {
            if (!refId) {
                deleteKomponentKriterler(modulId, komponentId, index);
                setOpen(false);
                return;
            }
            AdayBasvurularservice.deleteKomponentKriter({
                projId: user.iapId,
                adayId: user.userId,
                refId: refId,
                komponentId: komponentId,
                modulId: modulId,
            }).then((res) => {

                if (res && res.resultObject == true) {
                    deleteKomponentKriterler(modulId, komponentId, index);
                    setOpen(false);
                }
            })
        } catch (error) {
            console.log(error);
            showMessage.error(t('message.updateFailed'));
        } finally {
            setTimeout(() => {
                if (open) {
                    showMessage.error(t('message.updateFailed'));
                }
                setOpen(false); // Hide Backdrop

            }, 30000); // Delay to allow backdrop to appear for a short time
        }
    }


    /// this method to save and send to database 
    const saveKriterler = () => {

        setOpen(true);
        try {
            AdayBasvurularservice.register({
                projId: user.iapId,
                adayId: user.userId,
                kriterList: modulKriterler
            }).then((res) => {
                if (res && res.resultObject) {
                    showMessage.success(t('message.created'));
                    setIsChange(false);
                    validateCurrentBlock();
                    getKriterler();
                } else {
                    showMessage.error(t('message.updateFailed'));
                }
                setOpen(false);
                setClosed(true);
            });

            console.log("Saving selKriterler:", {
                basvuruformuId: user.basvuruformu,
                adayId: user.userId,
                kriterList: modulKriterler
            });
        } catch (error) {
            setOpen(false);
            console.log(error);
            showMessage.error(t('message.updateFailed'));
        } finally {
            setTimeout(() => {
                if (open) {
                    showMessage.error(t('message.updateFailed'));
                }
                setOpen(false); // Hide Backdrop

            }, 30000); // Delay to allow backdrop to appear for a short time
        }
    };

    const transformData = (data) => {
        let result = [];

        data.forEach((module) => {
            // Extract normal kriterler
            if (module.kriterler) {
                Object.entries(module.kriterler).forEach(([kriterId, kriter]) => {
                    result.push({
                        KriterId: parseInt(kriterId),
                        value: kriter.value,
                        text: kriter.text || null,
                        RefId: kriter.refId,
                    });
                });
            }

            // Extract komponentKriterler
            if (module.komponentKriterler) {
                module.komponentKriterler.forEach((komponent) => {
                    Object.entries(komponent).forEach(([kriterId, kriter]) => {
                        result.push({
                            KriterId: parseInt(kriterId),
                            value: kriter.value,
                            text: kriter.text || null,
                            RefId: kriter.refId,
                        });
                    });
                });
            }
        });

        return result;
    };

    const BasvuruFormuBlokZorunlu = async () => {

        var res = await BasvuruFormuBlokservice.kriterZorunlu({ id: basvuruFormBlokId });

        if (!res || !res?.resultObject) return { isValid: false, missingFields: [] };

        const list = res.resultObject;
        const kriterlerList = transformData(modulKriterler);

        const missingFields2 = list
            .filter(kriter =>
                kriter.zorunlu &&
                ((kriterlerList.some(
                    item => item.KriterId === kriter.bagliOlunanKriterId
                        && item.value === kriter.bagliOlunanKriterSecenekId))
                    || kriter.bagliOlunanKriterId == null
                    || kriter.bagliOlunanKriterSecenekId == null)

            ) // Check mandatory and presence in kriterlerList
            .filter(kriter => {
                const kriterItem = kriterlerList.find(item => item.KriterId === kriter.kriterId);
                return !kriterItem || kriterItem.value === null || kriterItem.value === "" || kriterItem.value === undefined; // Check if value is missing
            })
            .map(kriter => kriter.kriterDisplay); // Get the missing field names

        return {
            isValid: missingFields2.length === 0, // If there are no missing fields, it's valid
            missingFields: missingFields2 // List of missing mandatory fields
        };
    };

    const KomponentZorunlu = async ({ komponentId, komponentKriterler, modulId }) => {

        var res = await BasvuruFormuBlokservice.KomponentkriterZorunlu({ komponentId: komponentId, kriterModulId: modulId });

        if (!res || !res?.resultObject)
            return { isValid: false, missingFields: [] };


        const kriterlerList = res?.resultObject
        let missingFields = kriterlerList;

        const komponentList = transformKomponentData(komponentKriterler);

        if (komponentKriterler) {


            let filtered = kriterlerList.filter(kriter =>
                kriter.bagliOlunanKriterId == null || // null or undefined
                (
                    kriter.bagliOlunanKriterId > 0 &&
                    komponentList.some(item =>
                        item.KriterId === kriter.bagliOlunanKriterId &&
                        (item.value === kriter.bagliOlunanKriterSecenekId || kriter.bagliOlunanKriterSecenekId == null))
                )
            );

            missingFields = filtered
                .filter(kriter => {

                    const kriterItem = komponentList.find(item => item.KriterId === kriter.kriterId);
                    return !kriterItem || kriterItem.value === null || kriterItem.value === ""; // Check if value is missing
                })
                .map(kriter => kriter.kriterDisplay); // Get the missing field names
        }


        return {
            isValid: missingFields.length === 0, // If there are no missing fields, it's valid
            missingFields: missingFields // List of missing mandatory fields
        };
    }


    const transformKomponentData = (komponentKriterler) => {
        let result = [];

        komponentKriterler.forEach((komponent) => {
            Object.entries(komponent).forEach(([kriterId, kriter]) => {
                result.push({
                    KriterId: parseInt(kriterId),
                    value: kriter.value,
                    text: kriter.text || null,
                    RefId: kriter.refId,
                });
            });
        });

        return result;

    }

    const validateCurrentBlock = useCallback(async () => {

        console.log('Start Validate');

        console.log(basvuruFormBlokId);
        console.log(modulKriterler);


        const result = await BasvuruFormuBlokZorunlu(); // Await the result

        console.log(result);

        if (result.isValid) {
            setIsPageValid(false);
        } else {
            setIsPageValid(true);
        }
    }, [basvuruFormBlokId, modulKriterler, isChange]);


    useEffect(() => {
        // only run if we have a block ID
        if (!basvuruFormBlokId) return;

        let active = true; // guard against setting state on unmounted component

        (async () => {
            console.log("Start Validate", { basvuruFormBlokId, modulKriterler });
            const result = await BasvuruFormuBlokZorunlu();
            console.log("Validation result:", result);

            if (active) {
                // note: isValid===true means no missing fields, so page is valid → false error
                setIsPageValid(!result.isValid);
            }
        })();

        return () => {
            active = false;
        };
    }, [basvuruFormBlokId, modulKriterler]);


    return (
        <BasvuruContext.Provider
            value={{
                modulKriterler,
                updateSelKriterler,
                saveKriterler,
                updateKomponentKriterler,
                deleteKomponentKriterler,
                getKriterler,
                deleteFromDb,
                setDialogMessage,
                setDialogTitle,
                setOnConfirm,
                setConfirmOpen,
                setbasvuruFormBlokId,
                BasvuruFormuBlokZorunlu,
                KomponentZorunlu,
                isChange,
                isPageValid,
                isClose,
                setClosed,
                isChange,
                setIsChange
            }}>
            {children}
            <Backdrop
                sx={{
                    color: '#fff',
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    position: 'fixed', // Ensure it covers the full screen
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>


            <Dialog
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                fullWidth
                maxWidth="sm"
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    {dialogTitle}
                    <IconButton onClick={() => setConfirmOpen(false)} size="small">
                        <CloseSharp />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Typography>
                        {dialogMessage}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmOpen(false)}>{t('button.cancel')}</Button>
                    <Button
                        onClick={() => {

                            saveKriterler(); // Execute the function only if it's defined
                            setConfirmOpen(false);

                        }}
                        color="primary"
                    >
                        {t('button.confirm')}
                    </Button>
                </DialogActions>
            </Dialog>
        </BasvuruContext.Provider>
    );
};

export const useShareContext = () => useContext(BasvuruContext);
